async function refreshSalesforceChatToken() {
  if (!SOPHIA.loggedIn()) return;

  const result = await SOPHIA.ajax({
    dataType: 'json',
    method: 'POST',
    url: SOPHIA.Routes.salesforce_chat_tokens_path()
  });

  // Set identity token for Salesforce.
  window.embeddedservice_bootstrap.userVerificationAPI.setIdentityToken({
    identityTokenType: "JWT",
    identityToken: result.token
  });
}

window.addEventListener("onEmbeddedMessagingReady", refreshSalesforceChatToken);
window.addEventListener("onEmbeddedMessagingIdentityTokenExpired", refreshSalesforceChatToken);
